const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
const BASE = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * Verify onboarding token validity (Dynamic365)
 * @param {string} token
 * @returns {Promise<{success:boolean, valid:boolean, message?:string}>}
 */
export const verifyOnBoardingToken = async (token) => {
  try {
    const response = await fetch(`${BASE}/dynamic365/verify-onBoarding-token?token=${encodeURIComponent(token)}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(API_KEY && { 'X-API-Key': API_KEY }),
      },
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to verify onboarding token');
    }
    return data;
  } catch (error) {
    console.error('OnBoarding token verification error:', error);
    throw error;
  }
};

/**
 * Set password using onboarding token (Dynamic365)
 * @param {string} token
 * @param {string} newPassword
 * @returns {Promise<any>}
 */
export const setOnBoardingPassword = async (token, newPassword) => {
  try {
    const response = await fetch(`${BASE}/dynamic365/set-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(API_KEY && { 'X-API-Key': API_KEY }),
      },
      body: JSON.stringify({ token, newPassword }),
    });

    const data = await response.json();
    if (!response.ok) {
      throw new Error(data.message || 'Failed to set onboarding password');
    }
    return data;
  } catch (error) {
    console.error('OnBoarding set password error:', error);
    throw error;
  }
};